import { render, staticRenderFns } from "./CostOfLiving.vue?vue&type=template&id=a957d0a0&"
import script from "./CostOfLiving.vue?vue&type=script&lang=js&"
export * from "./CostOfLiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports